










































































































































import { Component, Prop} from 'vue-property-decorator';
import { DialogForm, FormOverlay } from '../../bwaff';

import ErrorAggregator from '../../errors/error-aggregator.vue';
import Form, { Send } from '../../form-base';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '../../ui/mixins/plan-limits-mixin';
import BillingApi from '../../../services/rest/bemob/billing';
import ManageAddonEstimate from '@/components/dialogs/manage-addon/manage-addon-estimate.vue';
import ManageAddonNotAmount from '@/components/dialogs/manage-addon/manage-addon-not-amount.vue';
import BillingMixin from '@/mixins/billing-mixin';
import IntercomMixin from '@/components/helpers/intercom-mixin';

const numeralFormat = require('numeral');

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    ManageAddonEstimate,
    ManageAddonNotAmount
  },
})
export default class ManageAddon extends mixins(IntercomMixin, PlanLimitsMixin, Form, BillingMixin) {
  active: boolean = false;
  billingApi: BillingApi = new BillingApi();
  switchOffButtonLoading = false;
  submitButtonLoading = false;
  estimate = null;

  errors: any[] = [];
  errorsControlActive: boolean = false;
  
  @Prop({ default: {} })
  data: {  
    planLimit: null | keyof BillingLimits 
  };
  
  customAmount: number = this.$store.state.billing.addons[this.data.planLimit]?.addonLimit || 0;
  amount: number | 'custom' = this.$store.state.billing.addons[this.data.planLimit]?.addonLimit || 0;

  mounted() {
    this.active = true;
    this.$on('error', (e: any) => {
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });
  }

  get isAddonEnabled() {
    return !!this.$store.state.billing.addons[this.data.planLimit]
  }

  get addonsOwnedNow() {
    return this.$store.state.billing.addons[this.data.planLimit]?.addonLimit || 0
  }

  get dialogTitle() {
    if(this.isSwitchOffMode || this.estimate?.estimateType==='delete') return this.t('Switch Off Add-on')
    if(this.estimate) return this.t('Confirm Purchase')
    if(!this.isAddonEnabled) return this.t('Buy as Add-on')
    if(this.isManagingMode) return this.t('Manage Add-ons')
  }

  get isAllowedToBuyOnlyHundreds() {
    return ['campaignsAmount','offersAmount','landingsAmount','flowsAmount'].includes(this.data.planLimit)
  }

  get isAllowedToBuyOnlyDozens() {
    return ['trafficSourcesAmount','affiliateNetworksAmount'].includes(this.data.planLimit)
  }

  calculatePerUnit() {
    return Math.round(this.calculatePerMonth()/this.customAmount)
  }

  formattedPerMonth(pack) {
    return numeralFormat(Math.round(this.calculatePerMonth(pack))/100).format('0,0.00')
  }

  formattedPerUnit(pack) {
    return numeralFormat(Math.round(this.calculatePerMonth(pack)/pack)/100).format('0,0.00')
  }

  onCustomBlur() {
    if(this.isAllowedToBuyOnlyHundreds){
      this.customAmount = Math.ceil(this.customAmount / 100) * 100;
      return
    }
    if(this.isAllowedToBuyOnlyDozens){
      this.customAmount = Math.ceil(this.customAmount / 10) * 10;
      return
    }

    this.customAmount = isNaN(this.customAmount) ? this.customAmount : Number(this.customAmount); 
  }

  calculatePerMonth(customAmount=this.customAmount) {
    customAmount=Number(customAmount)
    if(isNaN(customAmount)) return;
    if(customAmount === 0) return 0; 
    
    if(this.billingAddon.pricing_model==='tiered'){
    
     let restCustomValue = customAmount
     return this.billingAddon.tiers.reduce((acc,tier)=>{
    
       if(customAmount >= tier.starting_unit && !tier.ending_unit){
         acc=acc +restCustomValue*tier.price
       }
    
       if(customAmount > tier.ending_unit){
         const unitAmount = tier.ending_unit-tier.starting_unit+1
         restCustomValue=restCustomValue-unitAmount
         acc=acc + unitAmount*tier.price
       }
       
       if(customAmount >= tier.starting_unit && customAmount <= tier.ending_unit){
         const unitAmount = customAmount-tier.starting_unit+1
         restCustomValue=restCustomValue-unitAmount
        
         acc=acc + unitAmount*tier.price
       }
       return acc;
     },0)
    }
    
    if(this.billingAddon.pricing_model==='volume'){
     const tier = this.billingAddon.tiers.find((tier)=>{
       if(customAmount >= tier.starting_unit && customAmount <= tier.ending_unit){
          return true;
       }
       if(customAmount >= tier.starting_unit && !tier.ending_unit){
          return true;
       }
     })
     return tier.price * customAmount
    }
    
    if(this.billingAddon.pricing_model==='stairstep'){
     const tier = this.billingAddon.tiers.find((tier)=>{
       if(customAmount >= tier.starting_unit && customAmount <= tier.ending_unit){
          return true;
       }
       if(customAmount >= tier.starting_unit && !tier.ending_unit){
          return true;
       }
     })
     return tier.price
    }
    
    if(this.billingAddon.pricing_model==='per_unit'){
     return this.billingAddon.price * customAmount
    }
  }

  get submitButtonText() {
    if(this.isSwitchOffMode) return this.t('Switch Off')
    if(this.data.planLimit === 'uniqOfferViewerCondition') return this.t('Contact Team')
    if(this.estimate) return this.t('Confirm')
    if(!this.isAddonEnabled) return this.t('Buy Now')
    if(this.isManagingMode) return this.t('Update')
  }

  get isSubmitDisabled() {
    return this.switchOffButtonLoading || this.estimate?.estimateType === 'lessThan50cents'
  }

  get isManagingMode() {
    return !this.isOnOff && this.isAddonEnabled
  }

  get isSwitchOffMode() {
    return this.isOnOff && this.isAddonEnabled
  }

  get isBuyAmountMode() {
    return !this.isOnOff
  }

  get isBuyNotAmountMode() {
    return this.isOnOff && !this.isAddonEnabled
  }

  get isOnOff() {
    return this.billingAddon?.pricing_model==='flat_fee'
  }

  get billingAddon() {
    return this.$store.state.billingAddons[this.data.planLimit]
  }

  stopLoading() {
    this.switchOffButtonLoading = false;
    this.submitButtonLoading = false;
  }

  submit() {
    if(this.data.planLimit === 'uniqOfferViewerCondition'){
      this.openLiveSupport()
      return;
    }
    this.submitButtonLoading = true;
    const isManagingMode = this.isManagingMode;
    if(!this.estimate) return this.estimateAddon()

    if(this.isSwitchOffMode || this.estimate.estimateType === 'delete'){
      return this.deleteAddon()
    }
     
    return this.billingApi.manageAddon({
      id:this.data.planLimit,
      quantity:this.amountToSend
    })
    .then(()=>{
      this.afterSubmit({message: isManagingMode ? this.t('Updated successfully') : this.t('Added successfully')})
      this.$mixpanel?.track(isManagingMode ? 'addon_edit':'addon_add', {
        name:this.data.planLimit,
        planId:this.$store.state.billing.planId,
        quantity:this.amountToSend
      });
    })
    .finally(this.stopLoading)
  }

  afterSubmit({ message }) {
    this.bus.emit('toast-success', message);
    this.close()
  }

  clearErrors() {
    this.errors = [];
    this.errorsControlActive = false;
  }

  @Send()
  estimateAddon() {
    this.clearErrors()
    if(this.isSwitchOffMode){
      return this.deleteAddonEstimate()
    }
    return this.billingApi.manageAddon({
      id:this.data.planLimit,
      type: 'estimates',
      quantity: this.amountToSend
    }).then((res)=> {
      this.estimate = res.data.payload;
    }).catch((e)=> {
      if(e.response.data.message === 'SUBSCRIPTION_UPDATE_TOTAL_LESS_THAN_50_CENTS'){
        this.estimate = {
          ...e.response.data.payload,
          estimateType:'lessThan50cents'
        }
      }

      return Promise.reject(e);
    })
      .finally(this.stopLoading)
  }

  switchOff() {
    this.switchOffButtonLoading = true;
    this.deleteAddonEstimate()
  }
  
  get amountToSend(){
    if(this.isOnOff) return null
    if(this.amount==='custom' || !this.packageList) return this.customAmount;
    return this.amount
  }
  
  deleteAddonEstimate(){
    this.clearErrors()
    return this.billingApi.deleteAddon({id:this.data.planLimit,type:'estimates'})
      .then((res)=>{
        this.estimate = {
          ...res.data.payload,
          estimateType:'delete'
        }
      })
      .finally(this.stopLoading)
  }
  
  deleteAddon(){
    return this.billingApi.deleteAddon({id:this.data.planLimit}).then(()=>{
      this.bus.emit('toast-success', this.t('Switched off successfully'));
      this.close()
    })
      .finally(()=>{
        this.stopLoading()
        this.$mixpanel?.track('addon_delete', {
          name:this.data.planLimit,
          planId:this.$store.state.billing.planId,
        });
      })
  }

  backFromEstimate() {
    this.estimate = ''
  }

  get packageList() {
    switch (this.data.planLimit) {
      case 'campaignsAmount':
      case 'offersAmount':
      case 'landingsAmount':
      case 'flowsAmount':
      case 'trafficSourcesAmount':
      case 'affiliateNetworksAmount':
        return [100,500,1000]
      case 'customColumnsAmount':
        return [1,5,10,20]
      case 'memberAdminsAmount':
      case 'memberUsersAmount':
      case 'customConversionsAmount':
        return [1,3,5,10]
      case 'domainsAmount':
      case 'sharedReportsAmount':
      case 'redirectDomainsAmount':
        return [1,3,10]
      case 'dataRetention':
        return [3,6,9,12]
    }
  }

  close() {
    this.$emit('close');
  }
  
  get pricePerMonth(){
    if(this.isOnOff){
      return this.billingAddon.price
    }
    return this.calculatePerMonth(this.amount==='custom' ? this.customAmount : this.amount)
  }
}
